import Icon from "../../common/components/Icon";

const Loading = () => {
  return <Icon className="loader-wrap my-4" icon="loading" />;
};

export default Loading;
